import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateState = (props) => {
    const [CountryID, setCountryID] = useState('');
    const [StateName, setStateName] = useState('');
    const [StateCode, setStateCode] = useState('');
    const [Countrycmb, setCountrycmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        CountryID: Yup.string().required('Required!'),
        StateName: Yup.string().required('Required!'),
        StateCode: Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'State');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.CountryID);
        bodyFormData.append("Value2", values.StateName);
        bodyFormData.append("Value3", values.StateCode);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'State');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    const CountryData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Country');
        fetchComboData("Primary/List", bodyFormData);
    }

    const CountrydataOpt = (CountryOption) => {
        let CountryCombo = CountryOption.map((data) =>
            <option
                key={data.Country}
                value={data.id}
            >
                {data.Country}
            </option>
        );
        setCountrycmb(CountryCombo);
    };

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    useEffect(() => {
        CountrydataOpt(responseCombo);
    }, [responseCombo])

    useEffect(() => {
        if (responseGetData.length > 0) {
            setCountryID(responseGetData[0].CountryID);
            setStateName(responseGetData[0].State);
            setStateCode(responseGetData[0].StateCode);
        }
    }, [responseGetData])

    useEffect(() => {
        CountryData();
        if (props.PKID !== '') {
            getByIDData();
        }
    }, [])

    return (
        <div>
            <Formik initialValues={{ CountryID: CountryID, StateName: StateName, StateCode: StateCode }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    label='Country'
                                    name='CountryID'
                                    options={Countrycmb}
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='State Code'
                                    name='StateCode'
                                    onChange={(e) => setStateCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='State Name'
                                    name='StateName'
                                    onChange={(e) => setStateName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateState;
